module.exports = " <div class=vux-circle> <svg viewBox=\"0 0 100 100\"> <path :d=pathString :stroke=trailColor :stroke-width=trailWidth :fill-opacity=0 /> <path :d=pathString stroke-linecap=round :stroke=strokeColor :stroke-width=strokeWidth fill-opacity=0 :style=pathStyle /> </svg> <div class=vux-circle-content><slot></slot></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/circle/index.vue
// module id = 212
// module chunks = 2